import {Overlay} from "ol";

class BaseMeasureOverlay {

	constructor(map, uperpixel) {
		this.overlay = new Overlay({
			offset: [0, -10],
			positioning: 'bottom-center',
			className: 'ol-tooltip-measure ol-tooltip .ol-tooltip-static',
		});
		this.overlay.element.style.display = 'block';
		map.addOverlay(this.overlay);
		this.close();
		this.uperpixel = uperpixel;
	}

	close = () => {
		this.overlay.setPosition(undefined);
	}
}

export default BaseMeasureOverlay;
